import { clsx } from "clsx";
import { type HTMLAttributes } from "react";

interface PixelTextProps extends HTMLAttributes<HTMLSpanElement> {
  as?: "span" | "h1" | "h2" | "h3" | "p" | "div";
  glow?: "pink" | "blue" | "orange" | "green" | "none";
  size?: "sm" | "md" | "lg" | "xl" | "2xl";
}

// Accent variants now map to the GAME pixel palette with a single hard 1px ink
// drop-shadow (chiseled, no neon glow). Keys kept for API compatibility.
const glowMap = {
  pink: "text-[#c5a83a] [text-shadow:2px_2px_0_#1a1a1a]",
  blue: "text-[#3d6890] [text-shadow:2px_2px_0_#1a1a1a]",
  orange: "text-[#c54a4a] [text-shadow:2px_2px_0_#1a1a1a]",
  green: "text-[#5c7935] [text-shadow:2px_2px_0_#1a1a1a]",
  none: "text-[#1a1a1a]",
};

const sizeMap = {
  sm: "text-sm",
  md: "text-base",
  lg: "text-2xl",
  xl: "text-4xl",
  "2xl": "text-6xl",
};

export function PixelText({
  as: Tag = "span",
  glow = "pink",
  size = "md",
  className,
  ...props
}: PixelTextProps) {
  return (
    <Tag
      className={clsx(
        "font-mono font-bold uppercase tracking-widest",
        "[image-rendering:pixelated]",
        glowMap[glow],
        sizeMap[size],
        className
      )}
      {...props}
    />
  );
}
